import { Divider, Flex, FlexItem, H6, P } from "orcs-design-system";
import AppSwitchLink from "src/components/Nav/AppSwitchLink";
import { trackEvent } from "src/services/segment";
import { EVENT_TRACKING } from "src/consts/eventTracking";

const SUPPORT_PAGE_URL =
  "https://get.help.teamform.co/servicedesk/customer/portals";
const STATUS_PAGE_URL = "https://status.teamform.co";
const REQUEST_SUPPORT_URL =
  "https://get.help.teamform.co/servicedesk/customer/portal/2/create/10023";

type DefaultHelpMenuContentProps = {
  show: boolean;
  heading: string;
  description: string;
  supportLinkText: string;
  statusLinkText: string;
  showRequestSupport: boolean;
};

const DefaultHelpMenuContent = ({
  show,
  heading,
  description,
  supportLinkText,
  statusLinkText,
  showRequestSupport,
}: DefaultHelpMenuContentProps) => {
  if (!show) {
    return null;
  }

  return (
    <>
      <FlexItem>
        <H6 fontWeight="bold" mb="s">
          {heading}
        </H6>
        <P fontSize="1" mb="xs">
          {description}
        </P>
      </FlexItem>
      <Flex flexDirection="column" gap="r">
        <AppSwitchLink
          label={supportLinkText}
          href={SUPPORT_PAGE_URL}
          showFavicon={false}
          data-testid="support-page-link"
          onClick={() => {
            trackEvent(EVENT_TRACKING.URL_CLICKED, {
              action: "support_page_link_clicked",
            });
          }}
        />
        <AppSwitchLink
          label={statusLinkText}
          href={STATUS_PAGE_URL}
          showFavicon={false}
          data-testid="status-page-link"
          onClick={() => {
            trackEvent(EVENT_TRACKING.URL_CLICKED, {
              action: "status_page_link_clicked",
            });
          }}
        />
        {showRequestSupport && (
          <AppSwitchLink
            label="Request Support"
            href={REQUEST_SUPPORT_URL}
            showFavicon={false}
            data-testid="report-issue-link"
            onClick={() => {
              trackEvent(EVENT_TRACKING.URL_CLICKED, {
                action: "report_issue_link_clicked",
              });
            }}
          />
        )}
        <Divider light />
      </Flex>
    </>
  );
};

export default DefaultHelpMenuContent;
